// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1R-ZN","list":"BalanceDue_list__16aVm","listRow":"BalanceDue_listRow__6Krdg","total":"BalanceDue_total__1Rbpc"};